import React from "react";
import { PadlockLockedFillIcon } from "@navikt/aksel-icons";
import { useRenameCSS } from "../theme/Theme.js";
import { useI18n } from "../util/i18n/i18n.hooks.js";
export const ReadOnlyIcon = () => {
    const { cn } = useRenameCSS();
    return (React.createElement(PadlockLockedFillIcon, { "aria-hidden": true, className: cn("navds-form-field__readonly-icon") }));
};
export const ReadOnlyIconWithTitle = () => {
    const { cn } = useRenameCSS();
    return (React.createElement(PadlockLockedFillIcon, { title: useI18n("global")("readOnly"), className: cn("navds-form-field__readonly-icon") }));
};
//# sourceMappingURL=ReadOnlyIcon.js.map